import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material';
import { useCompanyBranding } from 'src/views/authentication/auth/useCompanyBranding';
import defaultLogo from 'src/assets/images/logos/logo-tclc.png';

const LinkStyled = styled(Link)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '70px',
  width: 'auto',
  textDecoration: 'none',
}));

const LogoContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginTop: '-15px',
}));

const LogoImage = styled('img')(() => ({
  width: '90%',
  height: '90%',
  objectFit: 'contain',
  display: 'block',
  marginTop: '25px',
}));

const Logo = ({ forceDefault = false }) => {
  const { companyName, companyLogoUrl } = useCompanyBranding();
  const resolvedLogo = useMemo(
    () => (forceDefault ? defaultLogo : companyLogoUrl),
    [companyLogoUrl, forceDefault]
  );
  const resolvedName = useMemo(
    () => (forceDefault ? 'Quotly' : companyName),
    [companyName, forceDefault]
  );

  return (
    <LogoContainer>
      <LinkStyled to="/">
        <LogoImage src={resolvedLogo} alt={resolvedName} />
      </LinkStyled>
    </LogoContainer>
  );
};

export default Logo;
